module.exports = __webpack_public_path__ + "img/39_24.3a11b868.png";